import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/board/excel_ico.png'
import _imports_1 from '@/assets/sns/Twitter.png'
import _imports_2 from '@/assets/sns/Bluesky.png'
import _imports_3 from '@/assets/sns/Google.png'
import _imports_4 from '@/assets/sns/Naver.png'
import _imports_5 from '@/assets/sns/Youtube.png'
import _imports_6 from '@/assets/sns/Instagram.png'
import _imports_7 from '@/assets/board/delete_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-f3be06f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_search_wrap" }
const _hoisted_7 = { class: "monitoring_menu" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "전체", -1))
const _hoisted_9 = { class: "board_top" }
const _hoisted_10 = { class: "board_top_btns" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "count" }
const _hoisted_15 = { class: "board_list" }
const _hoisted_16 = { class: "board_table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "3%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "4%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "6%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "auto" }),
  /*#__PURE__*/_createElementVNode("col", { width: "4%" })
], -1))
const _hoisted_18 = { class: "chk" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "연번", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "담당자", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색유형", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색키워드", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색이미지", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색 플랫폼", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색일시", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색종료일", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색진행률", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "구분", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "검색결과", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "삭제", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "chk" }
const _hoisted_34 = ["value"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "board_thumb"
}
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = { class: "pop_sns_box" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { key: 3 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 4 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 5 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "col_spinner" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "search_txt_box" }
const _hoisted_62 = { class: "total_count" }
const _hoisted_63 = {
  type: "button",
  class: "delete_btn"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { colspan: "14" }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = { colspan: "14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      class: _normalizeClass($setup.state.filterData.sns?.length === $setup.snsList.length ? 'active' : '')
                    }, [
                      _hoisted_8,
                      _createElementVNode("p", null, _toDisplayString($setup.list.cntData?.cntAll?.toLocaleString() ?? 0) + " 건 검색", 1),
                      _createElementVNode("p", null, _toDisplayString($setup.list.cntData?.cntResultAll?.toLocaleString() ?? 0), 1)
                    ], 2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.snsList, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass($setup.state.filterData.sns?.length === 1 && item.idx === $setup.state.filterData.sns[0] ? 'active' : '')
                      }, [
                        _createElementVNode("p", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, [
                          (item.idx === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString($setup.list.cntData?.cntX?.toLocaleString() ?? 0), 1)
                              ], 64))
                            : (item.idx === 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString($setup.list.cntData?.cntGoogle?.toLocaleString() ?? 0), 1)
                                ], 64))
                              : (item.idx === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString($setup.list.cntData?.cntNaver?.toLocaleString() ?? 0), 1)
                                  ], 64))
                                : (item.idx === 4)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString($setup.list.cntData?.cntYoutube?.toLocaleString() ?? 0), 1)
                                    ], 64))
                                  : (item.idx === 5)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createTextVNode(_toDisplayString($setup.list.cntData?.cntInstagram?.toLocaleString() ?? 0), 1)
                                      ], 64))
                                    : (item.idx === 6)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _createTextVNode(_toDisplayString($setup.list.cntData?.cntBluesky?.toLocaleString() ?? 0), 1)
                                        ], 64))
                                      : _createCommentVNode("", true),
                          _createTextVNode(" 건 검색 ")
                        ]),
                        _createElementVNode("p", null, [
                          (item.idx === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString($setup.list.cntData?.cntResultX?.toLocaleString() ?? 0), 1)
                              ], 64))
                            : (item.idx === 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString($setup.list.cntData?.cntResultGoogle?.toLocaleString() ?? 0), 1)
                                ], 64))
                              : (item.idx === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString($setup.list.cntData?.cntResultNaver?.toLocaleString() ?? 0), 1)
                                  ], 64))
                                : (item.idx === 4)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString($setup.list.cntData?.cntResultYoutube?.toLocaleString() ?? 0), 1)
                                    ], 64))
                                  : (item.idx === 5)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createTextVNode(_toDisplayString($setup.list.cntData?.cntResultInstagram?.toLocaleString() ?? 0), 1)
                                      ], 64))
                                    : (item.idx === 6)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _createTextVNode(_toDisplayString($setup.list.cntData?.cntResultBluesky?.toLocaleString() ?? 0), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 256))
                  ])
                ]),
                _createVNode(_component_Filter, {
                  sns: true,
                  resultType: false,
                  resultDetailType: false,
                  nation: false,
                  isMonitoring: false,
                  selectOption: $setup.state.selectOption,
                  onSearch: $setup.filterSearch,
                  onReset: $setup.filterSearch
                }, null, 8, ["selectOption", "onSearch", "onReset"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.deleteLists && $setup.deleteLists(...args)))
                  }, "선택삭제"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(" 총 "),
                  _createElementVNode("span", null, _toDisplayString($setup.numberFormat($setup.state.totalLength)) + "건", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("label", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.checkAll) = $event)),
                            onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.checkAllList()))
                          }, null, 544), [
                            [_vModelCheckbox, $setup.state.checkAll]
                          ]),
                          _hoisted_19
                        ])
                      ]),
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31
                    ])
                  ]),
                  (!$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, [
                              _createElementVNode("label", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.checkList) = $event)),
                                  value: item.idx
                                }, null, 8, _hoisted_34), [
                                  [_vModelCheckbox, $setup.state.checkList]
                                ]),
                                _hoisted_35
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.idx), 1),
                            _createElementVNode("td", null, _toDisplayString(item.meName), 1),
                            _createElementVNode("td", null, _toDisplayString(item.strType), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(item.keyword.length > 12 ? 'more_txt' : ''),
                                onClick: ($event: any) => ($setup.moreText(item.keyword))
                              }, _toDisplayString(item.keyword), 11, _hoisted_36)
                            ]),
                            _createElementVNode("td", null, [
                              (item.imgPath)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("img", {
                                      src: item.imgPath,
                                      alt: "",
                                      onClick: ($event: any) => ($setup.showImg(item.imgPath))
                                    }, null, 8, _hoisted_38)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_39, [
                                (item.isTwitter === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _hoisted_42))
                                  : _createCommentVNode("", true),
                                (item.isBluesky === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _hoisted_45))
                                  : _createCommentVNode("", true),
                                (item.isGoogle === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, _hoisted_48))
                                  : _createCommentVNode("", true),
                                (item.isNaver === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, _hoisted_51))
                                  : _createCommentVNode("", true),
                                (item.isYoutube === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, _hoisted_54))
                                  : _createCommentVNode("", true),
                                (item.isInstagram === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, _hoisted_57))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.createDate)), 1),
                            _createElementVNode("td", _hoisted_58, [
                              (item.analysisCompDate)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString($setup.formatDate(item.analysisCompDate)), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(item.progress ? item.progress : 0) + "% ", 1),
                                _hoisted_59,
                                _createTextVNode(" " + _toDisplayString(item.progress < 100 ? "분석중" : "처리완료"), 1)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "blue_btn",
                                onClick: ($event: any) => ($setup.resultBtn(item.idx))
                              }, "검색결과", 8, _hoisted_60)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("span", _hoisted_62, " 총 " + _toDisplayString(item.cntResult ? $setup.numberFormat(item.cntResult) : 0) + " 건 ( " + _toDisplayString(item.currentPaging) + " / " + _toDisplayString(item.cntTotalPaging) + " ) ", 1)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", _hoisted_63, [
                                _createElementVNode("img", {
                                  src: _imports_7,
                                  alt: "",
                                  onClick: ($event: any) => ($setup.deleteList(item.idx))
                                }, null, 8, _hoisted_64)
                              ])
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.list.data.length === 0 && !$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_65, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_66, [
                            _createVNode(_component_NoResult)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_67, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_68, [
                            _createVNode(_component_Spinner)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              ($setup.list.data.length !== 0 && !$setup.state.isLoading)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.state.currentPage,
                    totalLength: $setup.state.totalLength,
                    perPage: $setup.state.perPage,
                    onOnPaging: $setup.handlePageChange
                  }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isModalOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"])
  ], 64))
}